(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-vtv-section]');
  if (!sections.length) return;

  function parseVideoUrl(url) {
    if (!url) return null;
    var m;
    m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (m) return { type: 'youtube', id: m[1] };
    m = url.match(/(?:vimeo\.com\/(?:video\/)?)(\d+)/);
    if (m) return { type: 'vimeo', id: m[1] };
    return { type: 'file', src: url };
  }

  function buildEmbed(parsed) {
    if (!parsed) return '';
    if (parsed.type === 'youtube') {
      return '<iframe src="https://www.youtube.com/embed/' + parsed.id +
        '?autoplay=1&rel=0&modestbranding=1" title="Témoignage vidéo" ' +
        'allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
    }
    if (parsed.type === 'vimeo') {
      return '<iframe src="https://player.vimeo.com/video/' + parsed.id +
        '?autoplay=1" title="Témoignage vidéo" ' +
        'allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    }
    var safe = String(parsed.src).replace(/"/g, '&quot;');
    return '<video controls autoplay playsinline src="' + safe + '"></video>';
  }

  sections.forEach(function (section) {
    var modal = section.querySelector('[data-vtv-modal]');
    if (modal && modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    var media = modal ? modal.querySelector('[data-vtv-media]') : null;
    var triggers = section.querySelectorAll('[data-vtv-play]');
    var closers = modal ? modal.querySelectorAll('[data-vtv-close]') : [];
    if (!modal || !media) return;

    var lastTrigger = null;
    var keyHandler = null;

    function getFocusable() {
      return Array.prototype.slice.call(
        modal.querySelectorAll('button:not([disabled]), [href], iframe, video, [tabindex]:not([tabindex="-1"])')
      );
    }

    function open(trigger) {
      var url = trigger.getAttribute('data-video-url');
      var parsed = parseVideoUrl(url);
      if (!parsed) return;
      lastTrigger = trigger;
      media.innerHTML = buildEmbed(parsed);
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';

      var closeBtn = modal.querySelector('.vtv-modal__close');
      if (closeBtn) closeBtn.focus();

      keyHandler = function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'Tab') {
          var focusables = getFocusable();
          if (!focusables.length) { e.preventDefault(); return; }
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
          }
        }
      };
      document.addEventListener('keydown', keyHandler);
    }

    function close() {
      modal.setAttribute('aria-hidden', 'true');
      media.innerHTML = '';
      document.documentElement.style.overflow = '';
      if (keyHandler) {
        document.removeEventListener('keydown', keyHandler);
        keyHandler = null;
      }
      if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () { open(btn); });
    });
    closers.forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
